import { Sprout } from "lucide-react";

const ITEMS = [
  "Natur erleben",
  "Gemeinschaft pflegen",
  "Seit 1918",
  "Berlin-Rosenthal",
  "Ihr Rückzugsort im Grünen",
  "KGA Schönwald e.V.",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-[#D8D3C5] bg-[#EFECE4] py-5" data-testid="marquee-banner">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display italic text-xl sm:text-2xl text-[#1A382B]">{item}</span>
                <Sprout size={16} className="text-[#C85A32]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
